/* eslint-disable */
import { useEffect, useRef } from 'react';

import i18n from 'i18n';
import { submitSurveyService } from 'services/assignments';
import { HeartRiskMatrixItem } from 'services/systems/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { saveTranslation } from 'store/systems';
import {
  PROCESS_DELAY,
  SUBMIT_QUEUE,
  SUBMIT_QUEUE_FAIL
} from 'utils/constants';
import { removeLocalStorage } from 'services/common/storage';

export const pushToQueue = (data: any, localKey: string) => {
  const dataLocal = localStorage.getItem(localKey);
  const dataSubmitLocal = dataLocal ? JSON.parse(dataLocal) as any[] : [];
  localStorage.setItem(localKey, JSON.stringify([...dataSubmitLocal, data]));
};

export const matrixKidneyRisk = (question92: 'yes' | 'no' | 'unknow', question101: 'unknow' | 'no' | 'stage_3' | 'stage_4_5') => {
  if (question92 === 'yes') {
    switch (question101) {
      case 'stage_3':
        return 'proteinuriaAndCdk3';
      case 'stage_4_5':
        return 'proteinuriaAndCdk45';
      default:
        return 'proteinuria';
    }
  } else {
    switch (question101) {
      case 'stage_3':
        return 'cdk3';
      case 'stage_4_5':
        return 'cdk45';
      // case 'no':
      // return 'none';
      default:
        return '';
    }
  }
};

export const scoredKidneyRisk = (data: any): string => {
  // Tính điểm nguy cơ thận
  if (data['question-000010-000001'] === 'unknow' || data['question-000010-000001'] === 'no') {
    let score = 0;
    if (data['question-000001'] === 'female') {
      score += 1;
    }
    if (Number(data['question-000002']) >= 50 && Number(data['question-000002']) <= 59) {
      score += 2;
    }
    if (Number(data['question-000002']) >= 60 && Number(data['question-000002']) <= 69) {
      score += 3;
    }
    if (Number(data['question-000002']) >= 70) {
      score += 4;
    }
    if (data['question-000004'] === 'yes') {
      score += 1;
    }
    if (data['question-000006'] === 'yes') {
      score += 1;
    }
    if (data['question-000008-000001'] === 'yes' || data['question-000008-000002'] === 'yes') {
      score += 1;
    }
    if (data['question-000009-000002'] === 'yes') {
      score += 1;
    }
    if (data['question-000013-000001'] === 'yes') {
      score += 1;
    }
    if (data['question-000013-000002'] === 'yes') {
      score += 1;
    }
    if (data['question-000013-000003'] === 'yes') {
      score += 1;
    }
    if (score >= 4) {
      return 'twentyPercent';
    }
    return 'zeroPercent';
  }
  // Mệnh đề cũ
  return matrixKidneyRisk(data['question-000009-000002'], data['question-000010-000001']);
};

const checkInRangeMinMax = (value: number, min: number | null, max: number | null) => {
  if (!min && !!max) {
    return value <= max;
  }
  if (!!min && !max) {
    return value >= min;
  }
  if (!!min && !!max) {
    return value >= min && value <= max;
  }
  return false;
};

export const matrixHeartRisk = (data: any, riskMatrix?: HeartRiskMatrixItem[]): { heartRiskCode: string | null, heartRiskScore: number | null } => {
  const clause1 = () => [
    data['question-000008-000001'],
    data['question-000008-000002'],
    data['question-000008-000003'],
    data['question-000008-000004'],
    data['question-000008-000005'],
    data['question-000009-000001'],
    data['question-000009-000002'],
    data['question-000009-000003']].some((value) => value === 'yes') || data['question-000010-000001'] === 'stage_4_5';
  const clause2 = () => data['question-000010-000001'] === 'stage_3';
  const clause3 = () => [data['question-000004'], data['question-000003'], data['question-000006'], data['question-000007']].every((value) => value === 'yes');
  const clause4 = () => data['question-000004'] === 'yes' && [data['question-000003'], data['question-000005'], data['question-000006'], data['question-000007']].some((value) => value === 'yes');
  const clause5 = () => data['question-000004'] === 'yes' && [data['question-000003'], data['question-000005'], data['question-000006'], data['question-000007']].some((value) => value === 'no' || value === 'unknow');
  const clause6 = () => [data['question-000011-000001'], data['question-000011-000002'], data['question-000012']].some((item) => item && item.value && item.value === 'unknow');
  const clause7 = () => data['question-000002'] < 40;

  switch (true) {
    case clause1():
      return {
        heartRiskCode: 'veryHigh',
        heartRiskScore: null,
      };
    case clause2():
      return {
        heartRiskCode: 'high',
        heartRiskScore: null
      };
    case clause3():
      return {
        heartRiskCode: 'veryHigh',
        heartRiskScore: null,
      };
    case clause4():
      return {
        heartRiskCode: 'high',
        heartRiskScore: null
      };
    case clause5():
      return {
        heartRiskCode: 'medium',
        heartRiskScore: null,
      };
    case clause6():
      return {
        heartRiskCode: 'missingHeartRisk',
        heartRiskScore: null,
      };
    case clause7():
      return {
        heartRiskCode: 'matrixAndLessAge',
        heartRiskScore: null
      };
    default:
      break;
  }

  if (!riskMatrix) {
    return {
      heartRiskCode: 'missingHeartRisk',
      heartRiskScore: null,
    };
  }

  const filterLv1 = riskMatrix.filter((item) => item.gender === data['question-000001']
    && checkInRangeMinMax(data['question-000002'], item.age.min, item.age.max)
    && item.smoking === data['question-000003']);
  const cholesterol = data['question-000011-000001'].value - data['question-000011-000002'].value;
  const bloodPressure = data['question-000012'];

  const isMg = data['question-000011-000001'].type === 'mg/dL';
  if (isMg) {
    if (bloodPressure.value < 100) {
      const result = filterLv1.filter((item) => checkInRangeMinMax(cholesterol, item.mgPerdL.min, item.mgPerdL.max) && checkInRangeMinMax(100, item.bloodPressure.min, item.bloodPressure.max));
      return result.length === 0 ? {
        heartRiskCode: 'missingHeartRisk',
        heartRiskScore: null,
      } : {
        heartRiskCode: result[0].risk.risk,
        heartRiskScore: result[0].risk.score
      };
    }

    if (bloodPressure.value > 179) {
      const result = filterLv1.filter((item) => checkInRangeMinMax(cholesterol, item.mgPerdL.min, item.mgPerdL.max) && checkInRangeMinMax(179, item.bloodPressure.min, item.bloodPressure.max));
      return result.length === 0 ? {
        heartRiskCode: 'missingHeartRisk',
        heartRiskScore: null,
      } : {
        heartRiskCode: result[0].risk.risk,
        heartRiskScore: result[0].risk.score
      };
    }

    const result = filterLv1.filter((item) => checkInRangeMinMax(cholesterol, item.mgPerdL.min, item.mgPerdL.max) && checkInRangeMinMax(bloodPressure.value, item.bloodPressure.min, item.bloodPressure.max));

    return result.length === 0 ? {
      heartRiskCode: 'missingHeartRisk',
      heartRiskScore: null,
    } : {
      heartRiskCode: result[0].risk.risk,
      heartRiskScore: result[0].risk.score
    };
  }

  if (bloodPressure.value < 100) {
    const result = filterLv1.filter((item) => checkInRangeMinMax(cholesterol, item.mmolPerL.min, item.mmolPerL.max) && checkInRangeMinMax(100, item.bloodPressure.min, item.bloodPressure.max));
    return result.length === 0 ? {
      heartRiskCode: 'missingHeartRisk',
      heartRiskScore: null,
    } : {
      heartRiskCode: result[0].risk.risk,
      heartRiskScore: result[0].risk.score
    };
  }

  if (bloodPressure.value > 179) {
    const result = filterLv1.filter((item) => checkInRangeMinMax(cholesterol, item.mmolPerL.min, item.mmolPerL.max) && checkInRangeMinMax(179, item.bloodPressure.min, item.bloodPressure.max));
    return result.length === 0 ? {
      heartRiskCode: 'missingHeartRisk',
      heartRiskScore: null,
    } : {
      heartRiskCode: result[0].risk.risk,
      heartRiskScore: result[0].risk.score
    };
  }
  const result = filterLv1.filter((item) => checkInRangeMinMax(cholesterol, item.mmolPerL.min, item.mmolPerL.max) && checkInRangeMinMax(bloodPressure.value, item.bloodPressure.min, item.bloodPressure.max));

  return result.length === 0 ? {
    heartRiskCode: 'missingHeartRisk',
    heartRiskScore: null,
  } : {
    heartRiskCode: result[0].risk.risk,
    heartRiskScore: result[0].risk.score
  };
};

const useOfflineSubmit = () => {
  const dispatch = useAppDispatch();
  const translations = useAppSelector((state) => state.systems.feTranslations);

  const timeoutRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const isProcessingRef = useRef(false);

  const filterData = (dataParams: any[]) => {
    const filtered = dataParams.filter((item) => {
      if (!item?.details || typeof item?.details !== 'object') return false;

      const hasValidField = Object.values(item?.details).every(
        (value) => value !== undefined && value !== null && value !== ''
      );

      return hasValidField;
    });
    return filtered;
  };

  const getQueueFail = () => {
    try {
      const dataFail = localStorage.getItem(SUBMIT_QUEUE_FAIL);
      const filteredFail = filterData(dataFail ? JSON.parse(dataFail) as any[] : []);
      localStorage.setItem(SUBMIT_QUEUE_FAIL, JSON.stringify(filteredFail));
      return filteredFail;
    } catch {
      removeLocalStorage(SUBMIT_QUEUE_FAIL);
      return [];
    }
  };

  const getQueue = () => {
    try {
      const data = localStorage.getItem(SUBMIT_QUEUE);
      const filtered = filterData(data ? JSON.parse(data) as any[] : []);
      localStorage.setItem(SUBMIT_QUEUE, JSON.stringify(filtered));
      const dataFail = getQueueFail();
      return [...filtered, ...dataFail];
    } catch {
      removeLocalStorage(SUBMIT_QUEUE);
      return [];
    }
  };

  const setQueue = (queue: any[]) => {
    localStorage.setItem(SUBMIT_QUEUE, JSON.stringify(queue));
  };

  const processNext = async () => {
    if (isProcessingRef.current) return;

    if (!navigator.onLine) {
      timeoutRef.current = setTimeout(processNext, PROCESS_DELAY);
      return;
    }

    const queue = getQueue();

    if (!queue.length) return;

    const item = queue[0];
    isProcessingRef.current = true;

    try {
      await submitSurveyService(item);

      // remove item nếu thành công
      queue.shift();
      setQueue(queue);
    } catch (error: any) {
      if (error?.response?.status === 429) {
        // nếu bị 429 → delay 60s
        timeoutRef.current = setTimeout(processNext, 60000);
        isProcessingRef.current = false;
        return;
      }
      if (error?.response?.status === 422) {
        // nếu bị 422 → remove item đó khỏi queue
        queue.shift();
        setQueue(queue);
        isProcessingRef.current = false;
        timeoutRef.current = setTimeout(processNext, PROCESS_DELAY);
        return;
      }
    }

    isProcessingRef.current = false;
    timeoutRef.current = setTimeout(processNext, PROCESS_DELAY);
  };

  useEffect(() => {
    processNext();
    window.addEventListener('online', processNext);

    return () => {
      window.removeEventListener('online', processNext);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    i18n.on('loaded', () => {
      const storeLanguages = {
        ...translations,
      };

      if (storeLanguages) {
        Object.keys(i18n.store.data).forEach((keyData) => {
          if (Object.values(i18n.store.data[keyData]?.translation).length > 0) {
            storeLanguages[keyData] = i18n.store.data[keyData];
          }
        });
      }
      dispatch(saveTranslation(storeLanguages));
    });
  }, [dispatch, translations]);
};

export default useOfflineSubmit;
